import React from 'react';
import { Typography, Flex } from 'antd';
import FormattedDate from './FormattedDate';
import { isMobile } from 'react-device-detect';
import { useInView } from 'react-intersection-observer';
import "../styles/announcement.scss";
import "../styles/announcement-mobile.scss";

const { Title } = Typography;

export const Announcement = ({announcement, onTrackView}) => {

    const imageExist = !(/\/null$/.test(announcement.image));
    const className = isMobile ? "announcement-mobile" : "announcement";

    const { ref } = useInView({
        triggerOnce: true,
        threshold: 1.0,
        onChange: (inView) => {
            if (inView && onTrackView) {
                onTrackView(announcement.id);
            }
        }
    });

    return (
        <div className={className}>
            {imageExist ? <div className={`${className}__image-wrapper`}>
                <img alt='Фото' className={`${className}__image-wrapper__image`}
                    src={announcement.image}
                />
            </div> : null}
            <Flex orientation="vertical" className={`${className}__flex ${imageExist ? `${className}__flex__with-image` : ''}`}>
                <Title className={`${className}__title`}>
                    {announcement.title}
                </Title>

                <div className={`${className}__text`}>
                    <div dangerouslySetInnerHTML={{ __html: announcement.text }} style={{ wordBreak: "break-word" }} />
                </div>
                <div className={`${className}__date-wrapper`} ref={ref}>
                    <FormattedDate className={`${className}__date`} date={announcement.date}></FormattedDate>
                </div>
            </Flex>
        </div >
    );

}